import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
    currentMapExtent: null,
    previousMapExtent: null,
    frozenMapExtent: null,
    currentMapScale: null,
    previousMapScale: null,
    currentMapZoom: null,
    previousMapZoom: null,
    currentMapResolution: null,
    previousMapResolution: null,
};

export const mapSlice = createSlice({
    name: 'map',
    initialState,
    reducers: {
        setCurrentMapViewObj: (state, action) => {
            state.previousMapExtent = state.currentMapExtent;
            state.previousMapScale = state.currentMapScale;
            state.previousMapResolution = state.currentMapResolution;
            state.previousMapZoom = state.currentMapZoom;
            state.currentMapExtent = action.payload.extent;
            state.currentMapScale = action.payload.scale;
            state.currentMapResolution = action.payload.resolution;
            state.currentMapZoom = action.payload.zoom;
        },
        setFrozenMapViewObj: (state, action) => {
            state.frozenMapExtent = state.currentMapExtent;
        },
    },
});

export const { setCurrentMapViewObj, setFrozenMapViewObj } = mapSlice.actions;

export default mapSlice.reducer;
